<template>
  <div class="screen backdrop">

    <div
        class="viewport"
        @click="togglePlay"
    >

      <div
          v-if="!exitMode && !summaryMode"
          class="exit"
      >
        <button
            @click.prevent.stop="exit"
            class="icon">
          <img src="../assets/icons_UI_icon_X.svg" alt="" />
        </button>
      </div>

      <div
          v-if="!summaryMode"
          class="errorCount"
      >
        <svg viewBox="0 0 23 20">
          <path d="M22.5612532,15.3643967 L14.1624461,1.48148148 C13.6057528,0.54958184 12.6133865,0 11.5,0 C10.3866135,0 9.3942472,0.54958184 8.83755393,1.48148148 L0.438746783,15.3643967 C-0.142150541,16.3201912 -0.142150541,17.4671446 0.414542728,18.4468339 C0.971235997,19.4265233 1.98780631,20 3.10119285,20 L19.8988071,20 C21.0363977,20 22.028764,19.4265233 22.5854573,18.4468339 C23.1421505,17.4671446 23.1421505,16.3201912 22.5612532,15.3643967 Z M11.6197917,16.9047619 C10.8877315,16.9047619 10.3020833,16.3227513 10.3020833,15.5952381 C10.3020833,14.8677249 10.8877315,14.2857143 11.6197917,14.2857143 C12.3518519,14.2857143 12.9375,14.8677249 12.9375,15.5952381 C12.9375,16.3227513 12.3518519,16.9047619 11.6197917,16.9047619 Z M13.1523529,7.02241371 L12.682474,12.4736308 C12.633013,12.9869741 12.1631341,13.3780928 11.6437943,13.329203 C11.1739154,13.2803131 10.8029584,12.9136393 10.7782279,12.4736308 L10.308349,7.02241371 C10.2341576,6.24017628 10.8276888,5.55571853 11.6190638,5.48238378 C12.4104388,5.40904902 13.1028919,5.99572709 13.1770833,6.77796452 C13.1523529,6.85129928 13.1523529,6.94907895 13.1523529,7.02241371 Z" fill="#FFFFFF"></path>
          <g fill="#A6CFB7" fill-opacity="0">
            <path d="M11.6197917,16.9047619 C10.8877315,16.9047619 10.3020833,16.3227513 10.3020833,15.5952381 C10.3020833,14.8677249 10.8877315,14.2857143 11.6197917,14.2857143 C12.3518519,14.2857143 12.9375,14.8677249 12.9375,15.5952381 C12.9375,16.3227513 12.3518519,16.9047619 11.6197917,16.9047619 Z M13.1523529,7.02241371 L12.682474,12.4736308 C12.633013,12.9869741 12.1631341,13.3780928 11.6437943,13.329203 C11.1739154,13.2803131 10.8029584,12.9136393 10.7782279,12.4736308 L10.308349,7.02241371 C10.2341576,6.24017628 10.8276888,5.55571853 11.6190638,5.48238378 C12.4104388,5.40904902 13.1028919,5.99572709 13.1770833,6.77796452 C13.1523529,6.85129928 13.1523529,6.94907895 13.1523529,7.02241371 Z"></path>
          </g>
        </svg>
        <span>{{ errors + '/' + questionAmount }} FEHLER</span>

      </div>

      <VideoContainer
          v-if="!summaryMode"
          ref="videoContainer"
          @question-found="handleQuestionFound"
          @question-missed="handleQuestionMissed"
          @finished="handleFinished"
          :questions="questions"
          :rewind="rewind"
          :perspectiveStart="this.$route.params.perspective"
      />

      <ExitModal
          v-if="exitMode"
          @resume="resume"
      />

      <ResultsModal
          v-if="summaryMode"
          :result="result"
      />

      <QuestionModal
          v-if="question && !exitMode"
          :question="question"
          @question-submit="handleQuestionSubmit"
          @question-rewind="handleRewind"
      />

    </div>
  </div>
</template>

<script>

import VideoContainer from "../components/VideoContainer";
import ExitModal from "../components/ExitModal";
import QuestionModal from "../components/QuestionModal";
import ResultsModal from "../components/ResultsModal";
import Questions from "../Questions";

export default {

  name: "PerspectiveDemo",
  components: {ExitModal, ResultsModal, QuestionModal, VideoContainer},
  data() {

    return {

      exitMode: false,
      summaryMode: false,
      wasPlaying: false, // keep playing state during "exit" dialogue

      questions: Questions,
      question: null,
      rewind: false,
      result: {},
      errors: 0,
      questionAmount: Questions.length,
      buzzed: [],
    }
  },
  mounted() {

    // need to reset questions state :/
    Questions.forEach((q) => {
      // reset (discovered/buzzered) perspective
      q.perspective = null;
    })
    console.dir(Questions);
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
        if (from === null || from.name !== 'Tutorial') {
            vm.$router.push('/');
        }
    });
  },
  methods: {
    exit(e) {
      this.exitMode = true;
      if (!this.question) {
        this.wasPlaying = this.$refs.videoContainer.pause();
      }
    },
    resume() {
      this.exitMode = false;
      if (!this.question && this.wasPlaying) {
        this.$refs.videoContainer.resume();
      }
    },
    togglePlay(e) {
      if (this.question === null && !this.exitMode) {
        e.preventDefault();
        if (this.$refs.videoContainer) {
          this.$refs.videoContainer.togglePlay(e);
        }
      }
    },
    handleQuestionFound(question, perspective) {
      console.log(
          'FOUND',
          question.perspective,
          question
      );

      this.question = question;

      if(!this.buzzed.includes(question.id)) {
        this.buzzed.push(question.id);
        this.errors++;
      }
    },
    handleFinished() {
      console.log('FINISH');

      this.summaryMode = true;

      // console.log(this.result);

    },
    handleQuestionMissed(question) {

      console.log(
          'MISSED',
          question.perspective,
          question
      );

      this.result[question.id] = {
        correct: false,
        missed: true,
        perspective: question.perspective,
      };

      this.removeQuestion(question);

    },
    handleQuestionSubmit(data) {

      data.perspective = this.question.perspective;

      this.result[this.question.id] = data;

      this.removeQuestion(this.question);
      this.question = null;
      this.rewind = false;

      this.$refs.videoContainer.continue(true);
    },
    handleRewind() {

      let rewindTo = 0;
      if (this.question !== null) {
        rewindTo = this.question.rewindTo;
      }
      this.question = null;
      this.rewind = true;
      this.$refs.videoContainer.rewindTo(rewindTo)

    },
    removeQuestion(question) {
      this.questions = this.questions.filter((value) => {
        return value.id !== question.id
      });
    }
  }
}
</script>

<style lang="scss" scoped>

.backdrop {
  background-image: url('../assets/BG.jpg');
  background-size: cover;
}

</style>
